/* 🤖 this file was generated by svg-to-ts */
export const DfIconThumbsUpSquare16: {
  name: 'thumbs-up-square-16';
  data: string;
} = {
  name: 'thumbs-up-square-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M14 0a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zM8.55 4.098a.66.66 0 0 0-.908.217L6.148 6.75A1 1 0 0 0 6 7.273v3.502a1 1 0 0 0 .679.947l.509.172A2 2 0 0 0 7.83 12h2.449a1 1 0 0 0 .949-.685l.67-2.017A2 2 0 0 0 12 8.667v-.426a.862.862 0 0 0-.743-.855l-2.204-.308a.5.5 0 0 1-.415-.62l.334-1.303a.967.967 0 0 0-.422-1.057zM4.5 7.008h-.014A.486.486 0 0 0 4 7.495v2.998a.5.5 0 1 0 1 0V7.509a.5.5 0 0 0-.485-.5z"/></svg>`
};
